import React from 'react';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { Inputs } from '../../../../types/Enums';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { getFlowsDataTestId } from '../../../../utils/testUtils';
import TextInput from './TextInput';

interface Props {
  question: FlowsQuestion;
}

/**
 * THIS COMPONENT IS TEMPORARY TO AVOID DATA TEST ID REFACTOR
 */
const TextInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { field, error, prefilled } = useFlowInputComponent({ question });
  return (
    <TextInput
      {...field}
      error={error}
      type={question.rules.data_type?.toLowerCase() || 'text'}
      data-test-id={getFlowsDataTestId(Inputs.INPUT, question)}
      prefilled={prefilled}
      symbol={question.rules.symbol}
      isDisabled={question.rules.is_disabled}
    />
  );
};

export default TextInputComponent;
